import { baseURL } from '..';
import { IScenario } from '../../shared/iProject';
import httpClient, { IPaginatedResponse, IResponse } from '../httpClient';
import { createHeaders, createRequest, paginationQuery } from '../util';
import { IGetVesselPreviewResponse } from './iApiResponse';

const ScenarioProvider = () => {
    const getScenarioByIdAsync = async (id: number): Promise<IResponse<IScenario>> => httpClient.getAsync(createRequest(baseURL, `/Scenario/GetScenario?id=${id}`, undefined), createHeaders());

    const getScenarioPreviewAsync = async (pageNumber?: number, pageSize?: number, filter?: string, withTests?: boolean): Promise<IResponse<IPaginatedResponse<IGetVesselPreviewResponse>>> =>
        httpClient.getAsync(createRequest(baseURL, '/Scenario/GetScenarioPreviews', paginationQuery(pageNumber, pageSize, filter, withTests)), createHeaders());

    const getScenarioByVesselTypeAsync = async (vesselType: string): Promise<IResponse<IScenario>> =>
        httpClient.getAsync(createRequest(baseURL, '/Scenario/GetScenarioByVesselType', `?vesselType=${vesselType}`), createHeaders());

    const updateScenarioAsync = async (payload: IScenario): Promise<IResponse<IScenario>> =>
        httpClient.putAsync(createRequest(baseURL, '/Scenario/UpdateScenario', undefined, payload), createHeaders());

    const insertScenarioAsync = async (payload: IScenario): Promise<IResponse<IScenario>> =>
        httpClient.postAsync(createRequest(baseURL, '/Scenario/InsertScenario', undefined, payload), createHeaders());

    const getAllScenarioPreviewAsync = async (pageNumber?: number, pageSize?: number, filter?: string): Promise<IResponse<IPaginatedResponse<IGetVesselPreviewResponse>>> =>
        httpClient.getAsync(createRequest(baseURL, '/Scenario/GetAllScenarioPreviews', paginationQuery(pageNumber, pageSize, filter)), createHeaders());

    return { getScenarioByIdAsync, getScenarioPreviewAsync, getAllScenarioPreviewAsync, getScenarioByVesselTypeAsync, updateScenarioAsync, insertScenarioAsync };
};

export default ScenarioProvider();
